export default {"src":"/_next/static/media/reset-password-success.3f1501a9.svg","height":85,"width":86,"blurWidth":0,"blurHeight":0};